import styled from 'styled-components'
import { queries } from '~/constants/mediaQuery'

export const Container = styled.div`
  margin-top: 20px;
`

export const ContentWrapper = styled.div`
  border: 1px solid #e4e9ec;
  border-radius: 8px;

  @media ${queries.more.md} {
    display: grid;
    grid-template-columns: 25% 1fr;
  }
`

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 25px;
`

export const Body = styled.div`
  padding: 25px 30px;
  max-width: 100vw;
`

export const FilterPanelContainer = styled.div`
  background: #fff;
  border-right: 1px solid #e4e9ec;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;

  & > div:last-child {
    border: none;
  }
`

export const FilterSection = styled.div`
  padding: 25px 30px;
  border-bottom: 1px solid #efefef;
`

export const SubHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  strong {
    font-size: 22px;
    color: #767676;
  }

  & > div:last-child {
    display: flex;
    gap: 10px;

    & > div {
      min-width: 160px;
    }
  }
`
